var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCamelot = function SvgCamelot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camelot_svg__camelot"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#camelot_svg__clip0_18538_52902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "camelot_svg__Ellipse_1587",
    d: "M8 16.0001C12.4183 16.0001 16 12.4184 16 8.00018C16 3.58194 12.4183 0.000244141 8 0.000244141C3.58172 0.000244141 0 3.58194 0 8.00018C0 12.4184 3.58172 16.0001 8 16.0001Z",
    fill: "#FFAF1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camelot_svg__Vector",
    d: "M9.38632 9.42401V16H6.63015V9.42401C5.05979 9.59201 3.99418 10.312 3.99418 10.312L2.99268 9.18401C4.63515 8.00801 7.07082 7.96801 7.07082 7.96801L7.47142 3.55201C7.20703 3.38401 7.03076 3.08001 7.03076 2.73601C7.03076 2.20001 7.47142 1.76001 8.00824 1.76001C8.54505 1.76001 8.98571 2.20001 8.98571 2.73601C8.98571 3.08001 8.80944 3.37601 8.54504 3.55201L8.94565 7.96801C8.94565 7.96801 11.3813 8.01601 13.0238 9.18401L12.0223 10.312C12.0223 10.312 10.9567 9.59201 9.38632 9.42401Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "camelot_svg__clip0_18538_52902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
};
export default SvgCamelot;